import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const linkPreviewCache = {};

const LinkPreview = ({ url, isDarkMode }) => {
  const { token } = useAuth();
  const [preview, setPreview] = useState(linkPreviewCache[url] || null);
  const [loading, setLoading] = useState(!linkPreviewCache[url]);

  useEffect(() => {
    if (linkPreviewCache[url]) return;
    let cancelled = false;
    const fetchPreview = async () => {
      try {
        const res = await axios.get(`${API}/link-preview`, {
          params: { url },
          headers: { Authorization: `Bearer ${token}` }
        });
        if (!cancelled && res.data.title) {
          linkPreviewCache[url] = res.data;
          setPreview(res.data);
        }
      } catch {}
      if (!cancelled) setLoading(false);
    };
    fetchPreview();
    return () => { cancelled = true; };
  }, [url, token]);

  if (loading || !preview || !preview.title) return null;

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className={`block mt-2 rounded-xl overflow-hidden border transition-colors hover:opacity-90 ${
        isDarkMode ? 'border-gray-700 bg-gray-800' : 'border-gray-200 bg-gray-50'
      }`}
      data-testid="link-preview"
    >
      {preview.image && (
        <img src={preview.image} alt="" className="w-full h-32 object-cover" onError={(e) => e.target.style.display = 'none'} />
      )}
      <div className="p-3">
        <p className={`text-sm font-medium line-clamp-2 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
          {preview.title}
        </p>
        {preview.description && (
          <p className={`text-xs mt-1 line-clamp-2 ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
            {preview.description}
          </p>
        )}
        <p className={`text-xs mt-1 truncate ${isDarkMode ? 'text-gray-500' : 'text-gray-400'}`}>
          {new URL(url).hostname}
        </p>
      </div>
    </a>
  );
};

export default LinkPreview;
